import { createRootRouteWithContext, Link, Outlet } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { UserMenu } from "@/components/layout/UserMenu";

interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
});

function RootLayout() {
  return (
    <div className="min-h-dvh flex flex-col">
      <header className="px-4 py-3 flex items-center gap-3">
        <Link
          to="/"
          className="font-display text-2xl text-locomotive-900 hover:text-rust-600"
        >
          mextrain
        </Link>
        <div className="ml-auto">
          <UserMenu />
        </div>
      </header>

      <main className="flex-1 px-4 pb-24">
        <Outlet />
      </main>

      <footer className="fixed inset-x-0 bottom-0 px-4 py-2 text-center font-mono text-[11px] text-muted-foreground">
        build {import.meta.env.VITE_BUILD_SHA ?? "dev"}
      </footer>
    </div>
  );
}
